

const linearAnimations = () => {
    gsap.registerPlugin(ScrollTrigger);
    
    const history = document.querySelector('#history');
    const historyTextWrapper = history.querySelector('.history__text');
    const mission = document.querySelector('#mission');
    const missionTextWrapper = mission.querySelector('.mission__bottom-text-container');
    const programmers = document.querySelector('#programmes');
    const programmersTextWrapper = programmers.querySelector('.programmes__content-wrap');
    const research = document.querySelector('#research');
    const researchTextWrapper = research.querySelector('.research__content-wrap');

    const ourNews = document.querySelector('#our-news');
    const newsTextWrapper = ourNews.querySelector('.our-news__list');
    const widthSize1280 = 1280;

    const animation = (element) => {
        gsap.to(element,{
            duration: 1.2,
            ease: "power4.out",
            stagger: 0.2,
            opacity: 1,
            y: 0
        })
    }

    let observer;
    function initObserver(block, wrapper, element) {
        if (window.innerWidth > widthSize1280) {
        observer = new IntersectionObserver(
            (entries) => {
              if (entries[0].isIntersecting &&
                block.classList.contains('slide--current')) {
                observer.unobserve(wrapper);
                
                animation(element);
            }
            },
            { threshold: 1.0 },
        );
        observer.observe( wrapper);
        } else {
          return;
        } 
    }
    
    initObserver(history, historyTextWrapper, ".history__text-par");
    initObserver(mission, missionTextWrapper, ".mission__anim");
    initObserver(programmers, programmersTextWrapper, ".programmes__card");
    initObserver(research, researchTextWrapper, ".research__card");
    // initObserver(ourNews, newsTextWrapper, '.our-news__descr');

}

module.exports = linearAnimations;